import axios from "axios";
import axiosInstance from '../Services/AxiosInstance';



export const Loginapi = async (lowercaseEmail, userPassword,) => {
    try {

        const payload = {

            emailOrUsername: lowercaseEmail,
            password: userPassword,
        };

        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/login`, payload);

        return response;
    } catch (error) {

        throw error;
    }
};




export const fetchUserInfo = async (email) => {
    try {
        const payload = {
            email: email.trim(),
        };

        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/Me`, payload);

        return response;
    } catch (error) {

        throw error;
    }
};

export const isUserExistApi = async (email, userType, code) => {
    try {
        const payload = {
            email: email.trim(),
            userType,
            "referral_code": code
        };



        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/user`, payload);

        return response;
    } catch (error) {
        console.log(error, "error")
        throw error;
    }
};


export const fetchOtherUserInfo = async (userID, profileCode) => {
    try {
        const payload = {
            ...(userID && { userID }),
            ...(profileCode && { profile: profileCode })
        };



        const response = await axiosInstance.post(`/user/get_user_profile`, payload);

        return response;
    } catch (error) {

        throw error;
    }
};